import { EntryIdentifier } from '®shared/container-structure';

export function getItemElementId(itemId: string): string {
  return `item_${itemId}`;
}

export function getItemElementSelector(itemId: string): string {
  return getSelectorForElementId(getItemElementId(itemId));
}

export function getItemMenuButtonId(itemId: string): string {
  return `item_${itemId}_menu-btn`;
}

export function getItemMenuButtonSelector(itemId: string): string {
  return getSelectorForElementId(getItemMenuButtonId(itemId));
}

export function getSectionMenuButtonId(sectionId: string): string {
  return `section_${sectionId}_menu-btn`;
}

export function getSectionMenuButtonSelector(sectionId: string): string {
  return getSelectorForElementId(getSectionMenuButtonId(sectionId));
}

export function getEntryMenuButtonSelector(entry: EntryIdentifier): string {
  const { id, type } = entry;
  return type === 'sections'
    ? getSectionMenuButtonSelector(id)
    : getItemMenuButtonSelector(id);
}

export function getEntryMenuButtonSelectorByContainerIdAndIndex(
  containerId: string,
  index: number,
): string {
  return (
    `div[data-container-id="${containerId}"] ` +
    `.c-container-node__section__child[data-container-index="${index}"] ` +
    '.c-edit-entry-menu button'
  );
}

export function getEmptySectionAddResourceButtonId(sectionId: string): string {
  return `section_${sectionId}_add-resource`;
}

export function getEmptySectionAddResourceButtonSelector(
  sectionId: string,
): string {
  return getSelectorForElementId(getEmptySectionAddResourceButtonId(sectionId));
}

function getSelectorForElementId(elementId: string): string {
  return `#${elementId}`;
}
